import { FieldError, UseFormRegisterReturn } from "react-hook-form"
import styled, { css } from "styled-components"
import { ErrorSpan } from "./ErrorSpan"

interface IInputPassthroughProps {
  min?: number
  placeholder?: string
  type: "text" | "number" | "tel"
}

interface IInputProps extends IInputPassthroughProps {
  error?: FieldError
  registration: UseFormRegisterReturn
  short?: boolean
  unit?: string
}

const BaseWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  align-items: center;
  column-gap: clamp(0.8rem, 0.66rem + 0.7vw, 1.5rem);
`
const InputWrapper = styled(BaseWrapper)<{
  $hasUnit: boolean
}>`
  ${(props) => {
    if (props.$hasUnit) {
      return css`
        grid-template-columns: 1fr auto;
        grid-template-areas:
          "input unit"
          "error .";
      `
    }
    return css`
      grid-template-columns: auto;
      grid-template-areas:
        "input"
        "error";
    `
  }}
`

const StyledInput = styled.input.attrs((props) => ({
  type: props.type,
  min: props.min !== undefined ? props.min : `none`,
}))`
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 0px;
  box-sizing: border-box;
  grid-area: input;
  padding: clamp(0.5rem, 0.4rem + 0.5vw, 1rem) clamp(1rem, 0.8rem + 1vw, 2rem);
  font-family: inherit;
`

const StyledErrorSpan = styled(ErrorSpan)`
  display: block;
  margin-block-start: clamp(0.25rem, 0.2rem + 0.25vw, 0.5rem);
`

const UnitSpan = styled.span`
  font-weight: 700;
  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);
  grid-area: unit;
  justify-self: end;
  line-height: 140%;
  letter-spacing: 0.04em;
`
const Input = (props: IInputProps) => {
  const { error, registration, unit, short, ...passthroughProps } = props

  return (
    <InputWrapper
      $hasUnit={!!unit}
      style={{ width: short ? `10rem` : `100% ` }}
    >
      <StyledInput {...passthroughProps} {...registration}></StyledInput>
      {unit && <UnitSpan>{unit}</UnitSpan>}
      {error && <StyledErrorSpan>{error.message}</StyledErrorSpan>}
    </InputWrapper>
  )
}

export { Input }
